import { render } from "./ClaimsListPage.vue?vue&type=template&id=e1845a9e&ts=true"
import script from "./ClaimsListPage.vue?vue&type=script&lang=ts"
export * from "./ClaimsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__